<template>
  <div class="flex min-h-screen">
    <div
      class="w-full md:w-4/5 bg-gray-50 px-6 md:px-32 py-6 md:py-16 border-r"
    >
      <FormRegistrasi v-model="form" v-if="step == 1" @next="goToNextStep" />
      <FormRegistrasiParent
        v-model="formParent"
        v-if="step == 2"
        @next="goToNextStep"
        @prev="goToPreviousStep"
      />
      <FormRegistrasiEducation
        v-model="formEdu"
        v-if="step == 3"
        @next="goToNextStep"
        @prev="goToPreviousStep"
      />
      <FormRegistrasiDocuments
        v-model="formDocuments"
        v-if="step == 4"
        @prev="goToPreviousStep"
        @submit="handleConfirm"
      />
    </div>
    <div class="w-0 hidden sm:block md:w-1/5">
      <MultiStepVue :step="step" @update-step="updateStep" />
      <div class="fixed right-4 bottom-0">
        <FormSVG></FormSVG>
      </div>
    </div>
    <div
      id="confirmation_submit"
      class="z-10 inset-0 overflow-y-auto"
      :class="confirm ? 'fixed' : 'hidden'"
    >
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div class="fixed inset-0 transition-opacity" aria-hidden="true">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >

        <div
          class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
            <button
              type="button"
              data-behavior="cancel"
              class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <span class="sr-only">Close</span>
              <svg
                class="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div class="sm:flex sm:items-start">
            <div
              class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10"
            >
              <svg
                class="h-6 w-6 text-blue-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <h3
                class="text-lg leading-6 font-medium text-gray-900"
                id="modal-headline"
              >
                Apakah kamu sudah yakin?
              </h3>
              <div class="mt-2">
                <p class="text-sm text-gray-500">
                  Pastikan semua data terisi dengan benar.
                </p>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              data-behavior="commit"
              @click="handleSubmit"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Yakin
            </button>
            <button
              type="button"
              data-behavior="cancel"
              @click="confirm = false"
              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:w-auto sm:text-sm"
            >
              Batal
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="isLoading ? 'fixed' : 'hidden'"
      class="bg-gray-500 opacity-75 inset-0 overflow-y-auto z-50 h-full w-full flex items-center justify-center"
    >
      <div class="flex items-center">
        <span class="text-3xl mr-4 text-white">Mengirim Data ... </span>
        <svg
          class="animate-spin h-8 w-8 text-gray-200"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      </div>
    </div>
    <!-- error modal -->
    <div
      class="z-10 inset-0 overflow-y-auto"
      id="my-modal"
      :class="errorList.length ? 'fixed' : 'hidden'"
    >
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div class="fixed inset-0 transition-opacity" aria-hidden="true">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >
        <div
          class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div>
            <div
              class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100"
            >
              <svg
                class="h-6 w-6 text-red-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-5">
              <h3
                class="text-lg leading-6 font-medium text-gray-900"
                id="modal-headline"
              >
                Gagal mendaftar
              </h3>
              <div class="mt-2">
                <li v-for="(error, index) in errorList" :key="index">
                  {{ error.msg }}
                </li>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-6">
            <button
              class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:text-sm"
              @click="errorList = []"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- success modal -->
    <div
      :class="isSuccess ? 'fixed' : 'hidden'"
      class="inset-0 p-4 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]"
    >
      <div class="w-full max-w-lg bg-white shadow-lg rounded-lg p-6 relative">
        <svg
          @click="isSuccess = false"
          xmlns="http://www.w3.org/2000/svg"
          class="w-3.5 cursor-pointer shrink-0 fill-gray-400 hover:fill-red-500 float-right"
          viewBox="0 0 320.591 320.591"
        >
          <path
            d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z"
            data-original="#000000"
          ></path>
          <path
            d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z"
            data-original="#000000"
          ></path>
        </svg>

        <div class="my-8 text-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-14 shrink-0 fill-green-500 inline"
            viewBox="0 0 512 512"
          >
            <path
              d="M383.841 171.838c-7.881-8.31-21.02-8.676-29.343-.775L221.987 296.732l-63.204-64.893c-8.005-8.213-21.13-8.393-29.35-.387-8.213 7.998-8.386 21.137-.388 29.35l77.492 79.561a20.687 20.687 0 0 0 14.869 6.275 20.744 20.744 0 0 0 14.288-5.694l147.373-139.762c8.316-7.888 8.668-21.027.774-29.344z"
              data-original="#000000"
            />
            <path
              d="M256 0C114.84 0 0 114.84 0 256s114.84 256 256 256 256-114.84 256-256S397.16 0 256 0zm0 470.487c-118.265 0-214.487-96.214-214.487-214.487 0-118.265 96.221-214.487 214.487-214.487 118.272 0 214.487 96.221 214.487 214.487 0 118.272-96.215 214.487-214.487 214.487z"
              data-original="#000000"
            />
          </svg>
          <h4 class="text-xl text-gray-800 font-semibold mt-4">
            Pendaftaran Sukses!
          </h4>
          <p class="text-sm text-gray-500 leading-relaxed mt-4">
            Terima kasih telah mendaftar. Data yang Anda kirimkan akan segera
            kami periksa untuk kelengkapannya. Kami akan menghubungi Anda
            melalui email yang terdaftar jika ada informasi lebih lanjut atau
            jika proses verifikasi telah selesai. <br />Mohon pastikan email
            Anda aktif dan cek secara berkala.
          </p>
        </div>

        <button
          type="button"
          @click="handleSuccess"
          class="px-5 py-2.5 w-full rounded-lg text-white text-sm border-none outline-none bg-indigo-800 hover:bg-indigo-700"
        >
          Okay
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
const apiUrl = process.env.VUE_APP_API_URL;
import MultiStepVue from "@/components/MultiStep.vue";
import FormRegistrasi from "@/components/FormRegistrasiPersonal.vue";
import FormRegistrasiParent from "@/components/FormRegistrasiParent.vue";
import FormRegistrasiEducation from "@/components/FormRegistrasiEducation.vue";
import FormRegistrasiDocuments from "@/components/FormRegistrasiDocuments.vue";
import FormSVG from "@/components/svg/FormIcon.vue";
import axios from "axios";

import { ref } from "vue";

const step = ref(1);
const confirm = ref(false);
const isLoading = ref(false);
const errorList = ref([]);
const isSuccess = ref(false);
// Membuat objek form dengan ref
const formEdu = ref({
  pendidikan_terakhir: "",
  tahun_lulus: "",
  fakultas_jurusan: "",
  sekolah_ma: "",
  tahun_lulus_ma: "",
  sekolah_smp: "",
  tahun_lulus_smp: "",
  sekolah_sd: "",
  tahun_lulus_sd: "",
});
const formDocuments = ref({
  file_ijazah: "",
  file_paspor: "",
});
const formParent = ref({
  nama_ayah: "",
  nama_ayah_arab: "",
  nama_ibu: "",
  nama_ibu_arab: "",
  nama_kakek: "",
  nama_kakek_arab: "",
  nomor_hp_ortu: "",
  pekerjaan_ortu: "",
  penghasilan_ortu: "",
});
const form = ref({
  nik: "",
  nama_lengkap: "",
  nama_arab: "",
  jenis_kelamin: "",
  status_pernikahan: "",
  tempat_lahir: "",
  tanggal_lahir: "",
  email: "",
  facebook: "",
  instagram: "",
  twitter: "",
  alamat: "",
  password: "",
  provinsi: "",
  kota_kab: "",
  kecamatan: "",
  kodepos: "",
  no_hp: "",
  pas_foto: "",
});

const handleConfirm = () => {
  confirm.value = true;
};
const goToNextStep = () => {
  step.value++;
  window.scrollTo({ top: 0, behavior: "smooth" });
};

// Fungsi untuk kembali ke langkah sebelumnya
const goToPreviousStep = () => {
  step.value--;
  window.scrollTo({ top: 0, behavior: "smooth" });
};
const handleSuccess = () => {
  isSuccess.value = false;
  window.location.href = "/";
};
const handleSubmit = async () => {
  confirm.value = false;
  isLoading.value = true;
  try {
    // Gabungkan semua objek form
    const formData = {
      ...form.value,
      ...formParent.value,
      ...formEdu.value,
      ...formDocuments.value,
    };

    // Kirim data ke server menggunakan Axios
    await axios.post(apiUrl + "/user/regist/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    isSuccess.value = true;
  } catch (error) {
    if (error.response && error.response.status === 400) {
      // Ambil pesan error dari backend
      errorList.value = error.response.data.errors || [
        { msg: "An error occurred" },
      ];
    } else {
      // Error handling lainnya
      errorList.value = [{ msg: "An unexpected error occurred" }];
    }
  }
  isLoading.value = false;
};
const updateStep = (newStep) => {
  step.value = newStep;
};
</script>

<style></style>
